import React, { useContext } from 'react';
import {AccountTree, PendingActions, CheckCircle, AddTask, HomeOutlined, AccountBalanceOutlined, HomeWorkOutlined, MailOutline, Drafts, ListAlt, Description, BarChart, InsertDriveFile, NotificationsActive,SettingsOutlined } from '@mui/icons-material';
import { MenuItemContainer } from './hoa-side-drawer-styled-content';
import { GlobalContext } from '../../context/hoa-global-context';
import { camelCaseToSeparatedWords } from '../../utility/helper';

const MenuItem = (menu: any) => {

    const { activeMenu, changeActiveMenu, updatePropertyData, property, updateMailData, mail, updateEmailData, email, updatePendingSource, pendingSource, updateSelectedValues } = useContext<any>(GlobalContext)

    const changeActiveMenuWrapper = (menuName:any) => {
        if (menuName === "Webhook") {
            changeActiveMenu(menuName, true);
        }
        else {
            changeActiveMenu(menuName);
        }

        if(menuName === 'Properties' || menuName === 'PropertiesPendingTask') {
            updatePropertyData({
				...property,
				data: [],
				pageNumber: 1,
				options: property.options,
				isLastPage: false,
				fetchingFilteredData: true,
			});
        }
        if(menuName === 'Mails' || menuName === 'PendingSource') {
            updateMailData({
				...mail,
				data: [],
				pageNumber: 1,
				options: mail.options,
				isLastPage: false,
				fetchingFilteredData: true,
			});
            updateEmailData({
				...email,
				data: [],
				pageNumber: 1,
				options: email.options,
				isLastPage: false,
				fetchingFilteredData: true,
			});
            updatePendingSource({
				...pendingSource,
				data: [],
				pageNumber: 1,
				options: pendingSource.options,
				isLastPage: false,
				fetchingFilteredData: true,
			});
            updateSelectedValues({});
        }
    }

    const alterNativeNames:any = {
        DataFieldConfigurator: camelCaseToSeparatedWords("DataFieldConfigurator"),
        PropertiesPendingTask: "Properties",
        PropertiesCompletedTask: "Properties",
        PendingSource: "Source",
        InvoiceDataMapping: "Invoice Data Mapping",
    };

    const iconMap:any = {
        HOAs: HomeOutlined,
        Municipalities: AccountBalanceOutlined,
        Properties: HomeWorkOutlined,
        Mails: MailOutline,
        Emails: Drafts,
        Requests: ListAlt,
        Documents: Description,
        Analytics: BarChart,
        Invoicing: InsertDriveFile,
        Webhook: NotificationsActive,
        DataFieldConfigurator: SettingsOutlined,
        PropertiesPendingTask: AddTask,
        PropertiesCompletedTask: CheckCircle,
        PendingSource: PendingActions,
        InvoiceDataMapping: AccountTree,
    };

    const IconComponent = iconMap[menu.name];

    return (
		<MenuItemContainer
			onClick={() => {
				changeActiveMenuWrapper(menu.name);
			}}
			className={`side-drawer-menu-item-container ${
				menu.name.toLowerCase() === activeMenu ? "active" : ""
			}`}
		>
			{IconComponent ? <IconComponent id="menu-item-icon" /> : null}
			<span className="text-787878-14px">{alterNativeNames[menu.name] || menu.name}</span>
		</MenuItemContainer>
	);
}

export default MenuItem;
